import loanSlice from './slice/loanSlice';
import orgSlice from './slice/orgSlice';
import paymentSlice from './slice/paymentSlice';
import roleSlice from './slice/roleSlice';
import userSlice from './slice/userSlice';

const userAction = userSlice.actions;
const roleAction = roleSlice.actions;
const orgAction = orgSlice.actions;
const loanAction = loanSlice.actions;
const paymentAction = paymentSlice.actions;

export { userAction, roleAction, orgAction, loanAction, paymentAction };
